import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateSurveyPayload } from '@app-store/slices/survey/createSurvey'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ICreateSurveyPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.survey.createSurvey
const { setAddQuestionModal } = rootActions.ui.settings

function* createSurveySagaTask({ payload }) {
    try {
        const response = yield axios.post(`/meeting/survey`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(setAddQuestionModal(false))
            notification.success({
                message: 'Survey created successfully.'
            })
            if (payload.sagaCB) {
                yield put(payload.sagaCB.onSuccess(response.result))
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createSurveySaga(): any {
    yield takeLatest<TaskAction>(onRequest, createSurveySagaTask)
}

export default createSurveySaga
